import { LegalDoc } from "@/components/LegalDoc";
import { useLang } from "@/context/LanguageContext";

const FR = {
  title: "Politique de Confidentialité",
  updated: "11 juillet 2026",
  sections: [
    { h: "1. Données collectées", p: [
      "Golden Terminal collecte les données strictement nécessaires au fonctionnement du Service : adresse email, nom, photo de profil (si connexion Google), et informations d'abonnement.",
      "Aucune donnée bancaire n'est stockée sur nos serveurs : les paiements sont traités et sécurisés par Stripe.",
    ] },
    { h: "2. Finalités", p: [
      "Vos données servent à : gérer votre compte et votre authentification, traiter vos abonnements, envoyer les emails transactionnels (réinitialisation de mot de passe, alertes macro, Golden Brief quotidien) via notre prestataire Resend, et améliorer le Service.",
    ] },
    { h: "3. Base légale", p: [
      "Le traitement repose sur l'exécution du contrat (fourniture du Service), votre consentement (emails d'alertes/Brief, que vous pouvez désactiver à tout moment) et notre intérêt légitime (sécurité, prévention de la fraude).",
    ] },
    { h: "4. Partage avec des tiers", p: [
      "Vos données ne sont jamais vendues. Elles sont partagées uniquement avec nos sous-traitants techniques nécessaires : Stripe (paiements), Resend (emails), et l'hébergeur. Ces prestataires sont tenus à la confidentialité.",
    ] },
    { h: "5. Conservation", p: [
      "Vos données sont conservées tant que votre compte est actif, puis supprimées ou anonymisées dans un délai raisonnable après la clôture, sous réserve des obligations légales de conservation (facturation).",
    ] },
    { h: "6. Sécurité", p: [
      "Les mots de passe sont stockés hachés (bcrypt). Les sessions sont protégées par jeton. Une protection anti-force-brute est en place. Les échanges se font via HTTPS.",
    ] },
    { h: "7. Vos droits", p: [
      "Conformément à la réglementation applicable (RGPD/LPRPDE), vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et d'opposition. Pour exercer ces droits, contactez support@goldenterminal.ca.",
    ] },
    { h: "8. Emails et désinscription", p: [
      "Vous pouvez activer/désactiver les alertes email et le Golden Brief à tout moment depuis la cloche de notifications. Les emails transactionnels essentiels (sécurité) ne peuvent être désactivés.",
    ] },
    { h: "9. Cookies", p: [
      "Golden Terminal utilise un stockage local (localStorage) pour maintenir votre session et vos préférences. Aucun cookie publicitaire tiers n'est utilisé.",
    ] },
  ],
};

const EN = {
  title: "Privacy Policy",
  updated: "July 11, 2026",
  sections: [
    { h: "1. Data collected", p: [
      "Golden Terminal collects only the data strictly necessary for the Service to work: email address, name, profile picture (if signing in with Google), and subscription information.",
      "No banking data is stored on our servers: payments are processed and secured by Stripe.",
    ] },
    { h: "2. Purposes", p: [
      "Your data is used to: manage your account and authentication, process your subscriptions, send transactional emails (password reset, macro alerts, daily Golden Brief) via our provider Resend, and improve the Service.",
    ] },
    { h: "3. Legal basis", p: [
      "Processing relies on the performance of the contract (providing the Service), your consent (alert/Brief emails, which you can disable at any time) and our legitimate interest (security, fraud prevention).",
    ] },
    { h: "4. Sharing with third parties", p: [
      "Your data is never sold. It is shared only with our necessary technical subcontractors: Stripe (payments), Resend (emails), and the host. These providers are bound by confidentiality.",
    ] },
    { h: "5. Retention", p: [
      "Your data is retained while your account is active, then deleted or anonymized within a reasonable period after closure, subject to legal retention obligations (billing).",
    ] },
    { h: "6. Security", p: [
      "Passwords are stored hashed (bcrypt). Sessions are protected by token. Brute-force protection is in place. Communications use HTTPS.",
    ] },
    { h: "7. Your rights", p: [
      "In accordance with applicable regulations (GDPR/PIPEDA), you have the right to access, rectify, erase, port and object to your data. To exercise these rights, contact support@goldenterminal.ca.",
    ] },
    { h: "8. Emails and unsubscribe", p: [
      "You can enable/disable email alerts and the Golden Brief at any time from the notification bell. Essential transactional emails (security) cannot be disabled.",
    ] },
    { h: "9. Cookies", p: [
      "Golden Terminal uses local storage (localStorage) to maintain your session and preferences. No third-party advertising cookies are used.",
    ] },
  ],
};

export default function Privacy() {
  const { lang } = useLang();
  const d = lang === "en" ? EN : FR;
  return <LegalDoc title={d.title} updated={d.updated} sections={d.sections} />;
}
